/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MdmPreviewEntitySearchHitDto
 */
export interface MdmPreviewEntitySearchHitDto {
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    entityType?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    label?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    subtitle?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    hostname?: string;
    /**
     * 
     * @type {string}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    hardwareUuid?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MdmPreviewEntitySearchHitDto
     */
    ipAddresses?: Array<string>;
}

/**
 * Check if a given object implements the MdmPreviewEntitySearchHitDto interface.
 */
export function instanceOfMdmPreviewEntitySearchHitDto(value: object): value is MdmPreviewEntitySearchHitDto {
    return true;
}

export function MdmPreviewEntitySearchHitDtoFromJSON(json: any): MdmPreviewEntitySearchHitDto {
    return MdmPreviewEntitySearchHitDtoFromJSONTyped(json, false);
}

export function MdmPreviewEntitySearchHitDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MdmPreviewEntitySearchHitDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'entityType': json['entityType'] == null ? undefined : json['entityType'],
        'label': json['label'] == null ? undefined : json['label'],
        'subtitle': json['subtitle'] == null ? undefined : json['subtitle'],
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'hostname': json['hostname'] == null ? undefined : json['hostname'],
        'hardwareUuid': json['hardwareUuid'] == null ? undefined : json['hardwareUuid'],
        'ipAddresses': json['ipAddresses'] == null ? undefined : json['ipAddresses'],
    };
}

export function MdmPreviewEntitySearchHitDtoToJSON(json: any): MdmPreviewEntitySearchHitDto {
    return MdmPreviewEntitySearchHitDtoToJSONTyped(json, false);
}

export function MdmPreviewEntitySearchHitDtoToJSONTyped(value?: MdmPreviewEntitySearchHitDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'entityType': value['entityType'],
        'label': value['label'],
        'subtitle': value['subtitle'],
        'sourceSystem': value['sourceSystem'],
        'hostname': value['hostname'],
        'hardwareUuid': value['hardwareUuid'],
        'ipAddresses': value['ipAddresses'],
    };
}

